import { Box, Breadcrumbs as JoyBreadcrumbs, Link, Skeleton } from '@mui/joy'
import { ParseKeys } from 'i18next'
import { useTranslation } from 'react-i18next'
import { Link as ReactRouterLink } from 'react-router-dom'
import { ChevronIcon } from '~/shared/ui/Icons'
import { Title } from './styled'

type Breadcrumb = {
  title?: string
  titleI18n?: ParseKeys
  link?: string
}

export type BreadcrumbsList = Breadcrumb[]

type BreadcrumbsProps = {
  list: BreadcrumbsList
  lastLoading?: boolean
}

export function Breadcrumbs({ list, lastLoading = false }: BreadcrumbsProps) {
  const { t } = useTranslation()
  return (
    <JoyBreadcrumbs
      data-testid='breadcrumbs'
      separator={<ChevronIcon />}
      sx={{
        '--Breadcrumbs-gap': '12px',
        padding: '12px 0 20px 10px',
      }}
    >
      {list.map(({ title, titleI18n, link }) => (
        <Box key={title || (titleI18n && t(titleI18n)) || '-'}>
          {link && (
            <Link component={ReactRouterLink} color='neutral' to={link}>
              <Title>{title || (titleI18n && t(titleI18n))}</Title>
            </Link>
          )}

          {!link && (
            <Title sx={{ position: 'relative' }}>
              <Skeleton
                loading={lastLoading}
                sx={{ borderRadius: '8px', minWidth: '100px' }}
              />
              {title || (titleI18n && t(titleI18n))}
            </Title>
          )}
        </Box>
      ))}
    </JoyBreadcrumbs>
  )
}
